<template>
  <v-overlay color="white" opacity="1">
    <div class="d-flex flex-column align-center">
      <span
        class="white--text font-weight-thin d-flex text-h3 flex-column pl-2 pr-5 mb-10"
        style="border: 2px solid white"
      >
        <img
          src="@/assets/logo.png"
          alt=""
          style="width: 150px; height: 30px"
        />
      </span>

      <v-progress-circular
        size="100"
        indeterminate
        color="accent"
      ></v-progress-circular>
    </div>
  </v-overlay>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
</style>